import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/w/roles')({
  staticData: { breadcrumb: 'Roles', breadcrumbKey: 'K_BREADCRUMB_ROLES' },
});
